import React from 'react'
import { FaInstagram, FaGithub, FaLinkedinIn,} from "react-icons/fa";
import { MdOutgoingMail } from "react-icons/md";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Kasher Shahzad</h3>
        <p className="text-lg font-normal text-gray-400">
          let's start the discussion.
        </p>
        <p className="text-base text-gray-400 tracking-wide">
       Feel free to reach out using the contact form. I'm here to assist you and look forward to hearing from you soon!
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+92309 7962528</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">gdemagv@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
          <a
            href="https://www.linkedin.com/in/kasher-shahzad-223579288/"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon hover:text-customBlue"
          >
            <FaLinkedinIn />
          </a>

          </span>
          <span className="bannerIcon">
          <a
            href="https://github.com/Kasher503"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaGithub />
          </a>

          </span>
          <span className="bannerIcon">
          <a
            href="https://www.instagram.com/kasher_shahzad/"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaInstagram />
          </a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ContactLeft
